export const toMeter = (value, unit) => {
  if (!value) return 0;

  switch (unit) {
    case "m":
      return value;

    case "cm":
      return value / 100;

    case "mm":
      return value / 1000;

    case "ft":
      return value * 0.3048;

    case "in":
      return value * 0.0254;

    case "yd":
      return value * 0.9144;

    default:
      return value;
  }
};
